import createApp from '@infotech/base-layout'
import servicesConfig from './servicesCRUD'
import logsConfig from './logsCRUD'

createApp({
  extensions: [
    servicesConfig,
    logsConfig,
  ],
  headerActionButton: null,
})
